import { render } from "./medical-records-model.vue?vue&type=template&id=7454c73f"
import script from "./medical-records-model.vue?vue&type=script&lang=js"
export * from "./medical-records-model.vue?vue&type=script&lang=js"

import "./medical-records-model.vue?vue&type=style&index=0&id=7454c73f&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__